<template>
<div>
  <Grid name="filterGridOperator" ref="filterGridOperator" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"  v-bind:databound="dataBound"></Grid>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'Operator',
  extends: BaseFilter,
  components: {
    Grid
  },
  data() {
    return {
      fieldName: 'operator_id',
      fieldLabel: 'Operador',
      gridRef: 'filterGridOperator',
      preload: [],
      schemaModelFields: {},
      url: 'operators',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'codle',
        title: 'Codle'
      }, {
        width: '160px',
        field: 'nif',
        title: 'NIF'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'webshop',
        title: 'WebShop',
        width: '200px',
        values: [{
          value: 0,
          text: 'Não'
        }, {
          value: 1,
          text: 'Sim'
        }]
      }],
      loaded: false,
      tableInitialized: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// OperatorsFilter.vue?42b3e5cf